const mapEl = document.querySelector('.js-event-map'),
    occasions = document.querySelectorAll('.js-event-address'),
    mapOptionsDefault = {
        zoom: 15,
        panControl: false,
        streetViewControl: false,
        scaleControl: true,
        mapTypeControl: false,
        scrollwheel: false,
        draggable: true
    };

let mapInitialZoom = true,
    markerCounter = 0,
    mapMarkers = [],
    mapCanvas,
    latlngbounds;

if(mapEl) {
    latlngbounds = new google.maps.LatLngBounds();

    // Create map canvas
    mapCanvas = new google.maps.Map(mapEl, mapOptionsDefault);

    // Attach listeners for zoom/bound change envets on the map
    // to limit how far in we get zoomed
    mapZoomEvents();

    // Loop over all event occassions, use lat/long or geocode address,
    // and save to markers array
    generateMapMarkers();
}


function mapZoomEvents() {
    // This is needed to set the zoom after fitbounds,
    google.maps.event.addListener(mapCanvas, 'zoom_changed', function () {
        var zoomChangeBoundsListener =
            google.maps.event.addListener(mapCanvas, 'bounds_changed', function () {
                if (mapCanvas.getZoom() > 15 && mapInitialZoom === true) {
                    // Change max/min zoom here
                    mapCanvas.setZoom(15);
                    mapInitialZoom = false;
                }

            google.maps.event.removeListener(zoomChangeBoundsListener);
        });
    });
}

function generateMapMarkers() {
    occasions.forEach(occassion => {
        let locationString = occassion.dataset.address,
            latitudeString = occassion.dataset.latitude,
            longitudeString = occassion.dataset.longitude,
            title = occassion.dataset.title,
            infoWindowContent = "<div class='event--map-infowindow'><h3>" + title + "</h3><p>" + locationString + "</p></div>",
            geocoder = new google.maps.Geocoder(),
            occasionLatLng = false;

        // Do we have any address data to work with?
        if (latitudeString === undefined && longitudeString === undefined && locationString === undefined) {
            // We can't do anything so just continue to the next loop iteration
            return true;
        } else {
            // If we have the latitude and longitude points, lets use those
            if ((latitudeString !== undefined && latitudeString !== '') && (longitudeString !== undefined && longitudeString !== '')) {
                occasionLatLng = new google.maps.LatLng(latitudeString, longitudeString);

                buildMarker(occasionLatLng, title, infoWindowContent);
            } else {
                // Geocode given address
                geocoder.geocode({'address': locationString}, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        occasionLatLng = results[0].geometry.location;

                        buildMarker(occasionLatLng, title, infoWindowContent);
                    }
                });
            }
        }
    });
}

function buildMarker(latLng, title, infoWindowContent) {
    // Add occassionLatLng to array of marker positions
    // so we can re-use them on any resize events
    mapMarkers.push(latLng);

    // Create actuall marker on the map
    var mapMarker = new google.maps.Marker({
            position    : latLng,
            map         : mapCanvas,
            title       : title
        }),
        infoWindow = new google.maps.InfoWindow({
            content: infoWindowContent
        });

    // Add event listener fon marker click to open info window
    google.maps.event.addListener(mapMarker, 'click', function () {
        infoWindow.open(mapCanvas, mapMarker);
    });

    // Extend the bounds of the map viewport to include this marker
    latlngbounds.extend(latLng);

    // Update marker counter by 1
    markerCounter++;

    // If we've added all the markers to our map let's set the final position and zoom level
    if (markerCounter === occasions.length) {
        setMapPositionAndZoom();
    }
}

function setMapPositionAndZoom() {
    // Set the map centre point
    mapCanvas.setCenter(latlngbounds.getCenter());
    mapCanvas.fitBounds(latlngbounds);
}

function resizeMap() {
    var centreLatLng = latlngbounds.getCenter();

    google.maps.event.trigger(mapCanvas, "resize");

    mapCanvas.setOptions(mapOptionsDefault);

    // Set initial zoom flag to true as we've altered things...
    mapInitialZoom = true;

    mapCanvas.setCenter(centreLatLng);
    mapCanvas.fitBounds(latlngbounds);
}